import { Avatar, Badge, Card, Container, Grid, Group, LoadingOverlay, Menu, Text, Title, useMantineTheme } from '@mantine/core';
import {
    useFirestoreDocumentData,
    useFirestoreQueryData
} from "@react-query-firebase/firestore";
import { signOut } from 'firebase/auth';
import { collection, doc, query, where } from "firebase/firestore";
import React, { useEffect, useState } from 'react';
import { useAuthState } from "react-firebase-hooks/auth";
import { BsPlusCircle } from 'react-icons/bs';
import { useNavigate } from 'react-router';
import AvatarPlaceholder from '../assets/profile-placeholder.png';
import AdaugaCrediteModal from "../components/AdaugaCrediteModal";
import AppLoadingAnimation from '../components/AppLoadingAnimation';
import BoardCard from "../components/BoardCard";
import Logo from '../components/Logo';
import MenuProfile from '../components/Modals/MenuProfile';
import SelfieModal from "../components/webcam/SelfieModal";
import { auth, firestore } from "../firebase";
import getDocument from '../utils/useFirestoreDocument';
import ModalCreateBoardComponent from "../components/Modals/ModalCreateBoardComponent";
import {useSearchParams} from "react-router-dom";
import ModalQRSelfie from '../components/Modals/ModalQRSelfie';
import {isMobile} from 'react-device-detect';
import DashboardMenu from '../components/Navbar/DashboardMenu';
import RecenteIcon from '../assets/RecenteIcon';
import OpenedFileIcon from '../assets/OpenedFileIcon';
import BlankRecentlyBg from '../assets/blank-recently-bg.svg';


const Dashboard = () => {
    const navigate = useNavigate();
    const [ user ] = useAuthState(auth);
    const [searchParams, setSearchParams] = useSearchParams();

    const userRef = doc(firestore, `users`, user?.uid || "a");
    const userData = useFirestoreDocumentData(["user", user?.uid || "a"], userRef);


    const [isAuthOpen, setIsAuthOpen] = useState(false);
    const [isCrediteOpen,  setIsCrediteOpened] = useState(false);

    const [openProfile,setOpenProfile] = useState(false);
    const [isSelfieOpen, setIsSelfieOpen] =  useState(!!searchParams.get("selfie"));
    const [openQRSelfie,setOpenQRSelfie] = useState(false);
    
    const [tabOpen,setTabOpen] = useState('recent');

    const [isCreateBoardOpened,setIsCreateBoardOpened] = useState(false);
    const userAvatar = getDocument('users')?.getDocument?.data?.avatar;

    const avatar = userAvatar ? `https://picboard.imgix.net/${userAvatar}` : AvatarPlaceholder;

    const createCredits = () => {
        setIsCrediteOpened(true);
    }


    const boardsCollection = collection(firestore, "boards");

    const boardsQuery = query(boardsCollection, where("owners", "array-contains", user?.uid || "a"));
    const {data: boards, isLoading: isBoardsLoading} = useFirestoreQueryData(["boards", user?.uid, "owners"], boardsQuery,{subscribe: true}, {enabled: !!user?.uid});




    const boardsViewedQuery = query(boardsCollection, where("activity", "array-contains", user?.uid || "a"));
    const {data: viewed, isLoading: isViewLoading} = useFirestoreQueryData(["boards", user?.uid, "viewed"], boardsViewedQuery,{subscribe: true}, {enabled: !!user?.uid});


    const toggleLogout = () => {
        signOut(auth).then(() => {
            window.location.reload();
        })
    }

    const createBoard = () => {
        if (userData?.data.credits <= 0) {
            setIsCrediteOpened(true);
            return;
        }

        if(userData?.data?.credits > 0 && userData?.data?.onboarded !== 2){
            return setOpenProfile(true);
        }

        setIsCreateBoardOpened(true);
    }

    useEffect(()=>{
        userData.refetch();
    },[openProfile]);


    useEffect(()=>{
        if(!user) {
            return setIsAuthOpen(true);
        }
    },[user]);

    useEffect(() => {
        setSearchParams({});
    }, [isSelfieOpen])


    const theme = useMantineTheme();

    const handleQRSelfie = () => {
        if(isMobile) {
            setIsSelfieOpen(true)
        } else {
            setOpenQRSelfie(true);
        }
    }

    if (isSelfieOpen) {
        return (<SelfieModal opened={isSelfieOpen} onClose={() => setIsSelfieOpen(false)}/>)
    }

    

    return (
        <div className="min-h-screen h-full w-full relative">
            <LoadingOverlay overlayOpacity={1} visible={isBoardsLoading} loader={<AppLoadingAnimation/>}/>

            <div className="w-full border-b border-gray-200 px-8 py-4 md:py-0 flex justify-between items-center">
                <div>
                    <Logo />
                </div>
                <div className="hidden md:flex items-center flex-1 justify-center">
                    <div onClick={() => setTabOpen('recent')} className="px-6 py-6 relative cursor-pointer">
                        <h1 className="text-xl font-[500] text-[#3c3c3c]">Recente</h1>
                        <div className={tabOpen === 'recent' ? "borderingActive" : "borderingInactive"}></div>
                    </div>
                    <div onClick={() => setTabOpen('create')} className="px-6 py-6 relative cursor-pointer">
                        <h1 className="text-xl font-[500] text-[#3c3c3c]">Create</h1>
                        <div className={tabOpen === 'create' ? "borderingActive" : "borderingInactive"}></div>
                    </div>
                </div>
                <DashboardMenu 
                    setOpenProfile={setOpenProfile}
                    handleQRSelfie={handleQRSelfie}
                    toggleLogout={toggleLogout}
                    createBoard={createBoard}
                />
            </div>

            <div className="bg-white z-20 w-full flex md:hidden justify-between items-center px-16 fixed bottom-0">
                <div onClick={() => setTabOpen('recent')} className={`flex gap-x-2 relative py-6 justify-center gap-y-1 items-center ${tabOpen === 'recent' ? 'opacity-100' : 'opacity-50'}`}>
                    {tabOpen === 'recent' && <div className="bg-[#3c3c3c] absolute -top-[3px] left-0 w-full h-[6px] rounded-full"></div>}
                    <RecenteIcon width={16} height={16} />
                    <h1 className="text-sm font-[500] text-[#3c3c3c]">Recente</h1>
                </div>
                <div onClick={() => setTabOpen('create')} className={`flex gap-x-2 relative py-6 justify-center gap-y-1 items-center ${tabOpen === 'create' ? 'opacity-100' : 'opacity-50'}`}>
                    {tabOpen === 'create' && <div className="bg-[#3c3c3c] absolute -top-[3px] left-0 w-full h-[6px] rounded-full"></div>}
                    <OpenedFileIcon width={16} height={16} />
                    <h1 className="text-sm font-[500] text-[#3c3c3c]">Create</h1>
                </div>
            </div>


            {
                tabOpen === 'create' &&
                (boards?.length > 0 ? 
                <Container fluid={true} style={{paddingBottom:'80px'}} className={'pt-10 px-8'}>
                    {/* <LoadingOverlay visible={isLoading}/> */}
                    <Grid>
                        {
                            boards?.map((item,index) => (
                                <Grid.Col className="cursor-pointer" xs={5} md={5} lg={3}>
                                    <BoardCard {...item} key={index} onClick={() => user?.isAnonymous ? setIsAuthOpen(true) : navigate(`/${item.subdomain}`)}/>
                                </Grid.Col>
                            ))
                        }
                    </Grid>
                </Container>
                :
                <Container className="pt-10" fluid={true}>
                    {/* <LoadingOverlay visible={isLoading}/> */}
                    <Title style={{lineHeight:'1'}} align="center" order={1}>Momentan nu ai nici un eveniment</Title>
                    <Title style={{marginTop:'1rem'}} align="center" order={2}>Adaugă un eveniment</Title>
                    <Container mt="lg" size={300}>
                        <Card shadow="sm" p={0} className="relative">
                            <div onClick={createBoard} className="absolute flex justify-center w-full h-full top-0 left-0 z-10" style={{background: 'linear-gradient( rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5) )'}}>
                                <BsPlusCircle color="white" className="cursor-pointer mt-16" size={60} />
                            </div>
                            <Card.Section className="fitBackground relative">
                                <div className="bg-gray-200 w-full h-[160px]"></div>
                            </Card.Section>
                            <Group position="apart" style={{ marginBottom: 5, marginTop: theme.spacing.sm, paddingBottom:'20px', paddingLeft:'20px', paddingRight:'20px' }}>
                                <Text weight={500}>Eveniment Nou</Text>
                                <Badge color="yellow" variant="light">
                                    Draft
                                </Badge>
                            </Group>
                        </Card>
                    </Container>
                </Container>
                )
            }

            {
                tabOpen === 'recent' && 
                    <Container fluid={true} style={{paddingBottom:'80px'}} className={'pt-10 px-8  '}>
                        {/* <LoadingOverlay visible={isLoading}/> */}
                        {viewed?.length > 0 ? 
                        <Grid>
                            {
                                viewed?.map((item,index) => (
                                    <Grid.Col className="cursor-pointer" xs={5} md={5} lg={3}>
                                        <BoardCard {...item} key={index} onClick={() => user?.isAnonymous ? setIsAuthOpen(true) : navigate(`/${item.subdomain}`)}/>
                                    </Grid.Col>
                                ))
                            }
                        </Grid>
                        :
                        <div className="w-full max-w-[700px] mx-auto">
                            <div className="w-full max-w-[175px] mb-6 mx-auto">
                                <img src={BlankRecentlyBg} alt="subscribe" className="w-full h-full" />
                            </div>
                            <Title align="center" style={{marginBottom:'0.5rem',color:'#3c3c3c'}} order={1}>Nu ai vizualizat nici o plansa recent</Title>
                        </div>
                        }
                    </Container>
            }


            <MenuProfile setOpened={setOpenProfile} opened={openProfile} />
            <ModalQRSelfie setOpened={setOpenQRSelfie} opened={openQRSelfie} />
            <AdaugaCrediteModal opened={isCrediteOpen} onClose={() => setIsCrediteOpened(false)}/>
            {isCreateBoardOpened &&  <ModalCreateBoardComponent setOpened={setIsCreateBoardOpened}/>}
            {/* {!user && <AuthModal />} */}
        </div>
    )
}

export default Dashboard